import { For } from '../c-mp/comp/For'
import { Icon } from '../c-mp/comp/Icon'
import { Slot } from '../c-mp/comp/Slot'
import { defineComponent } from '../c-mp/fun/defineComponent'
import { url } from '../c-mp/fun/url'
import { useMemo } from '../c-mp/fun/useMemo'
import { mutateState, useState } from '../c-mp/fun/useState'
import { andrisEmail } from '../fun/andrisEmail'
import { getAge } from '../fun/getAge'
import { getDataOrThrow } from '../fun/getDataOrThrow'
import { getPersonNameFormatted } from '../fun/getPersonNameFormatted'
import { isDead } from '../fun/isDead'
import { setPageTitle } from '../fun/setPageTitle'
import { ICON_PLUS } from '../icon/ICON_PLUS'
import { ICON_RADIO_OFF } from '../icon/ICON_RADIO_OFF'
import { ICON_RADIO_ON } from '../icon/ICON_RADIO_ON'
import { _ } from '../model/ccc'
import { PERSON_DETAILS } from '../model/PERSON_DETAILS'
import { Relationship } from '../model/Relationship'
import { PortraitComp } from './PortraitComp'

export const PageBirthdaysComp = defineComponent<{}>(
	'PageBirthdaysComp',
	(props, $) => {
		setPageTitle('Születésnapok')

		const data = getDataOrThrow()

		const state = useState('state', { month: new Date().getMonth() })

		const getBirthdays = useMemo('getBirthdays', () => {
			const value = `-${(state.month + 1).toString().padStart(2, '0')}-`
			return Object.values(data.personsById)
				.filter((it) => !isDead(data, it) && it.birthDate?.includes(value))
				.map((it) => ({
					day: parseInt(it.birthDate!.slice(-2), 10),
					person: it,
				}))
				.sort((a, b) => a.day - b.day)
		})

		return (
			<div class={_.ccc_page}>
				<h1>Születésnapok</h1>
				<div class={_.ccc_tiles__centered__compact}>
					{[
						'Január',
						'Február',
						'Március',
						'Április',
						'Május',
						'Június',
						'Július',
						'Augusztus',
						'Szeptember',
						'Október',
						'November',
						'December',
					].map((it, index) => (
						<button
							class={() => [
								_.ccc_button__rounded,
								state.month === index && _.ccc__selected,
							]}
							onclick={() => {
								mutateState($.debugName, 'set month [t9zw3i]', () => {
									state.month = index
								})
							}}
						>
							<Slot
								isTrustedHtml
								get={() =>
									state.month === index ? ICON_RADIO_ON : ICON_RADIO_OFF
								}
							/>{' '}
							{it}
						</button>
					))}
				</div>
				<h2>Parditkák</h2>
				<div class={_.ccc_tiles__centered}>
					<For
						debugName='Születésnapok: Parditkák'
						each={() =>
							getBirthdays().filter(
								(it) => it.person.relationship === Relationship.Parditka,
							)
						}
						render={({ get }) => (
							<a
								class={_.ccc_button__person}
								href={() => url`/person/${get().person.id}`}
							>
								<Slot get={() => get().day.toString()} />.
								<PortraitComp getPerson={() => get().person} />
								<div>
									<Slot
										get={() => getPersonNameFormatted(data, get().person)}
									/>
									<div class={_.ccc_date}>
										<b>
											<Slot
												get={() =>
													getAge(
														get().person.birthDate!,
														new Date().getFullYear() +
															get().person.birthDate!.slice(4),
													)?.toString()
												}
											/>{' '}
											éves
										</b>{' '}
										lesz
									</div>
								</div>
							</a>
						)}
					/>
					<a
						class={_.ccc_button__plus}
						href={andrisEmail(
							'Új születésnap',
							`És hiányoltam egy születésnapot:\n\n${PERSON_DETAILS}`,
						)}
						title='Új születésnap'
					>
						<Icon svg={ICON_PLUS} /> születésnap
					</a>
				</div>
				<h2>Rokonok</h2>
				<div class={_.ccc_tiles__centered}>
					<For
						debugName='Születésnapok: rokonok'
						each={() =>
							getBirthdays().filter(
								(it) => it.person.relationship !== Relationship.Parditka,
							)
						}
						render={({ get }) => (
							<>
								<a
									class={_.ccc_button__person}
									href={() => url`/person/${get().person.id}`}
								>
									<Slot get={() => get().day.toString()} />.
									<PortraitComp getPerson={() => get().person} />
									<div>
										<Slot
											get={() => getPersonNameFormatted(data, get().person)}
										/>
										<div class={_.ccc_date}>
											<b>
												<Slot
													get={() =>
														getAge(
															get().person.birthDate!,
															new Date().getFullYear() +
																get().person.birthDate!.slice(4),
														)?.toString()
													}
												/>{' '}
												éves
											</b>{' '}
											lesz
										</div>
									</div>
								</a>
							</>
						)}
					/>
					<a
						class={_.ccc_button__plus}
						href={andrisEmail(
							'Új születésnap',
							`És hiányoltam egy születésnapot:\n\n${PERSON_DETAILS}`,
						)}
						title='Új születésnap'
					>
						<Icon svg={ICON_PLUS} /> születésnap
					</a>
				</div>
			</div>
		)
	},
)
